module.exports = __webpack_public_path__ + "img/lamp2.95f325f7.svg";